import React from 'react';

import { withStyles } from '@mui/styles';

import PropTypes from 'prop-types';

import { Typography, IconButton, Toolbar, AppBar } from '@mui/material';

import { Close } from '@mui/icons-material';

import { useLangFile } from 'js/context/LanguageContext';

const styles = (theme) => ({
  title: {
    flexGrow: 1,
  },
});

const SuspendStationAppBar = ({ classes, onClose }) => {
  const LangFile = useLangFile();

  return (
    <AppBar color={'secondary'} position="static">
      <Toolbar variant="dense">
        <IconButton edge="start" color="inherit" onClick={onClose}>
          <Close />
        </IconButton>

        <Typography variant="h6" className={classes.title}>
          {LangFile.SuspendStationAppBar.title}
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

SuspendStationAppBar.propTypes = {
  onClose: PropTypes.func,
};

export default withStyles(styles)(SuspendStationAppBar);
